// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPlpTableColumns = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="13" viewBox="0 0 19 13">
            <path
                fillRule="evenodd"
                fill="currentColor"
                d="M0 .5v13h19V.5H0Zm12.85 5.364h5.6V2.88h-5.6v2.983Zm-6.149 0h5.597V2.88H6.701v2.983Zm-6.15 0h5.597V2.88H.55v2.983Zm12.298 3.54h5.6V6.42h-5.6v2.983Zm-6.148 0h5.597V6.42H6.701v2.983Zm-6.15 0h5.597V6.42H.55v2.983Zm12.298 3.539h5.6V9.96h-5.6v2.983Zm-6.148 0h5.597V9.96H6.701v2.983Zm-6.15 0h5.597V9.96H.55v2.983Z"
            />
        </svg>
    );
};

export default React.memo(IconPlpTableColumns);
